import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { getControlErrorMessage } from '../interfaces/form-error.interface';

@Pipe({
  name: 'formError',
  standalone: true,
  pure: false, // Set to false because form errors can change without the control reference changing
})
export class FormErrorPipe implements PipeTransform {
  transform(control: AbstractControl | null): string {
    if (!control) {
      return '';
    }
    return getControlErrorMessage(control);
  }
}
